import { appendContent } from '../doc-append-content'
import { showErrors } from '../open-error-modal'

import { getParagraphs } from './api'
import { elements } from './elements'
import { getLS, LS_KEYS, pushLS } from './ls'

export const getAndInsertParagraphs = async (context, window) => {
    const type = elements.docType.selectedOptions[0]?.value
    const projectId = elements.projectId.value
    const authKey = elements.authKey.value
    const enableCache = elements.useCache.checked

    const para = await getParagraphs({
        type,
        projectId,
        authKey,
        enableCache,
    }).catch(err => {
        showErrors(context, window, [err.message])
    })
    if (!para) return

    // {{{ LS mapping
    //const mp = getLS(LS_KEYS.lsKey) ?? {}
    //for (const p of para.paragraphs) {
        //if (p.sectionType != 'Table')
            //if (p.id && p.section && p.subsection) {
                //mp[p.section] ??= {}
                //mp[p.section][p.subsection] = p.id
            //}
    //}
    //pushLS(LS_KEYS.lsKey, mp)
    // }}}

    await appendContent(context, para, -1)
}
